import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const savedParams = Cookies.get("registrationParams")
  ? JSON.parse(Cookies.get("registrationParams"))
  : { isParamsExist: false, buyerId: null };

const initialState = {
  isParamsExist: savedParams.isParamsExist || false,
  buyerId: savedParams.buyerId || null,
};

const paramSlice = createSlice({
  name: "params",
  initialState,
  reducers: {
    setParamsExist(state, action) {
      const { exists, buyerId } = action.payload;
      state.isParamsExist = exists;
      state.buyerId = buyerId || null;

      Cookies.set(
        "registrationParams",
        JSON.stringify({ isParamsExist: state.isParamsExist, buyerId: state.buyerId }),
        { secure: true, sameSite: "Strict" }
      );
    },
    clearParams(state) {
      state.isParamsExist = false;
      state.buyerId = null;

      Cookies.remove("registrationParams");
    },
  },
});

export const { setParamsExist, clearParams } = paramSlice.actions;
export default paramSlice.reducer;
